export const geocodeAddress = async (address: string): Promise<{ lat: number; lng: number } | null> => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        address + ', Ireland'
      )}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
    );
    const data = await response.json();

    if (data.results && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      return { lat, lng };
    }

    return null;
  } catch (error) {
    console.error('Geocoding error:', error);
    return null;
  }
};

export const parseGoogleAddress = (result: any): {
  street: string;
  city: string;
  state: string;
  zipCode: string;
} => {
  const components = result.address_components;
  let street = '';
  let city = '';
  let state = '';
  let zipCode = '';

  components.forEach((component: any) => {
    const types = component.types;

    if (types.includes('street_number')) {
      street = component.long_name;
    }
    if (types.includes('route')) {
      street = street ? `${street} ${component.long_name}` : component.long_name;
    }
    if (types.includes('locality') || types.includes('postal_town')) {
      city = component.long_name;
    }
    if (types.includes('administrative_area_level_1')) {
      state = component.long_name;
    }
    if (types.includes('postal_code')) {
      zipCode = component.long_name;
    }
  });

  return { street, city, state, zipCode };
};
